import { useState, useImperativeHandle, forwardRef  } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';
import CCNAImage from './assets/CCNA Logo.png'


const NavAppBar = forwardRef((props, ref) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState('Home');

  useImperativeHandle(ref, () => ({
    handleMenuItem: (theMenu) => {
      handleMenuItem(theMenu);
    }
  }));

  const menuItems = ['Home','Hazardous History', 'Sensor Readings','Learn More','Summary of Violations'];
  //-----------------------------------------------------


  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const navigate = useNavigate();

  //-----------------------------------------------------
  const handleMenuItem = (theSetting) => {
    setCurrentMenuItem(theSetting);
    switch (theSetting) {
      case 'Home':
         navigate("/");
        break;
      case 'Hazardous History':
         navigate("/hazardhistory");
        break;

      case 'Learn More':
         navigate("/learnmore");
        break;

      case 'Sensor Readings':
         navigate("/sensorpurpleair");
        break;

      case 'Summary of Violations':
         window.open('https://sarasotapublic.com/docs/nuisance/US_Recycling_violations.pdf', '_blank');
        break;
    
      default:
        let WarningMsg = 'The menu "' + theSetting + '" is not supported.';
        alert(WarningMsg);
        break;
    }
  };

  //-----------------------------------------------------
  return (
    <>
      <AppBar position="static">
        {/* First Row: App Name */}
        <Toolbar>
          <Typography variant="h4" component="div" sx={{ marginLeft: '5px', marginTop: '5px',  flexGrow: 1, textAlign: 'left', fontWeight: 'bold', display: 'flex' }}
            onClick={() => { navigate("/") }}>
            <img alt="" style={{ width: '50px', horizontal: 'left', position: 'relative', top: '-4px', left: '-7px' }} src={CCNAImage} />US Recycling

          </Typography>
        </Toolbar>

        {/* Second Row: Menu or Hamburger */}
        <Toolbar sx={{ top: -10 }}>
          {isSmallScreen ? (
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
              <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box
                  sx={{ width: 250 }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <List>
                    {menuItems.map((text) => (
                      <ListItem button key={text}>
                        <ListItemText primary={text} onClick={() => { handleMenuItem(text) }} />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 1 }}>
              {menuItems.map((item) => (
                <Button key={item} onClick={() => { handleMenuItem(item) }}
                 sx={{color: currentMenuItem === item ? 'white':'#D7D7D7',
                      fontWeight: currentMenuItem === item ? 'bold':'regular'
                 }}>
                  {item}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
});

export default NavAppBar;
